import React from 'react';
import ReactModal from 'react-modal';
import { mergeClasses } from '@griffel/react';

ReactModal.setAppElement('#root');

const UIDrawerModal = ({ className, isOpen, onClose, children, shouldCloseOnOverlayClick = false }) =>
{
	let portalClassName = mergeClasses('modal-portal drawer-modal', className, isOpen ? 'is-opened': '');
	let overlayClassName = mergeClasses('modal-overlay drawer-modal', className);
	className = mergeClasses('modal drawer-modal', className);

	return (
		<ReactModal
			isOpen={isOpen}
			onRequestClose={onClose}
			className={className}
			portalClassName={portalClassName}
			overlayClassName={overlayClassName}
			closeTimeoutMS={400}
			shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
			shouldCloseOnEsc={true}
		>
			{children}
		</ReactModal>
	);
};

export default UIDrawerModal;